<template>
  <div id="map"></div>
</template>

<script>
import mapboxgl from "mapbox-gl";

import geojson from "../assets/geojson/ncp-data";

export default {
  name: "NcpMap",
  data() {
    return {
      map: null,
      geoMarker: null,
      navControl: new mapboxgl.NavigationControl(),
      fullscreenControl: new mapboxgl.FullscreenControl(),
      geolocateControl: new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true
      }),
      fullextentControl: null,
      show3D: false
    };
  },
  mounted() {
    // create markers for geocoding
    const el = document.createElement("div");
    el.className = "mapboxgl-user-location-dot";
    this.geoMarker = new mapboxgl.Marker(el);

    // initialize map
    this.renderMap();
  },
  methods: {
    renderMap() {
      mapboxgl.accessToken =
        "pk.eyJ1IjoiYXNscGF2aW5nIiwiYSI6ImNqeWtjZHh0bzBkMHozZHBheWg0MTN5ZzcifQ.tExCy6szVJE7rKHDbfF0dQ";
      const mapOptions = {
        container: "map",
        attributionControl: false,
        style: "mapbox://styles/aslpaving/cjz1h4gde4k7f1cpkbs6g6kwa",
        center: [-106.596988, 52.174],
        zoom: 13
      };

      const map = (this.map = new mapboxgl.Map(mapOptions));

      map.on("load", () => {
        this.initGeoJSON();
        this.map.addControl(this.geolocateControl, "top-left");
      });
    },
    initGeoJSON() {
      const map = this.map;
      const _this = this;

      // // outline layer
      map.addLayer({
        id: "omrBounds",
        type: "line",
        source: {
          type: "geojson",
          data: geojson.omrBounds
        },
        layout: {},
        paint: {
          "line-width": 1.1,
          "line-opacity": 0.5,
          "line-color": "yellow"
        }
      });

      // fill layer
      map.addLayer({
        id: "omrBounds-fill",
        type: "fill-extrusion",
        source: {
          type: "geojson",
          data: geojson.omrBounds
        },
        paint: {
          "fill-extrusion-color": "yellow",
          "fill-extrusion-opacity": 0.08
        }
      });

      // // cons limit outline layer
      map.addLayer({
        id: "consLimit",
        type: "line",
        source: {
          type: "geojson",
          data: geojson.consLimit
        },
        layout: {},
        paint: {
          "line-width": 1.1,
          "line-opacity": 0.5,
          "line-color": "aqua"
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#map {
  position: absolute;
  overflow-x: auto;
  top: 56px;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NcpMap.vue